import roles from "@/roles";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layout/main.vue"),
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/index.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/open-access-policy",
        name: "open-access-policy",
        component: () => import("@/views/open-access-policy.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/faq",
        name: "faq",
        component: () => import("@/views/faq.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/open-um",
        name: "open-um",
        component: () => import("@/views/open-um.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/services/research",
        name: "services-research",
        component: () => import("@/views/research-services.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/services/technological",
        name: "services-technological",
        component: () => import("@/views/technological-services.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/services",
        redirect: { name: "services-research" },
        meta: {
          isAuthenticated: false,
        },
      },

      {
        path: "/research/infrastructure",
        name: "research-infrastructure",
        component: () => import("@/views/research-infrastructure.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/research/equipment",
        name: "research-equipment",
        component: () => import("@/views/research-equipment.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/research/equipment/:id",
        name: "research-equipment-detail",
        component: () =>
          import(
            "@/modules/research-equipment/components/research-equipment-selected-item-view.vue"
          ),
        meta: {
          isAuthenticated: false,
        },
      },

      {
        path: "/research",
        redirect: { name: "research-infrastructure" },
        meta: {
          isAuthenticated: false,
        },
      },

      {
        path: "/research/services",
        name: "research-services",
        component: () => import("@/views/services.vue"),
        meta: {
          isAuthenticated: false,
        },
      },

      {
        path: "/about-us",
        name: "about-us",
        component: () => import("@/views/about-us.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/terms-and-conditions",
        name: "terms-and-conditions",
        component: () => import("@/views/terms-and-conditions.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/accessibility",
        name: "accessibility",
        component: () => import("@/views/accessibility.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/gdpr-rights-employee",
        name: "gdpr-rights-employee",
        component: () => import("@/views/gdpr-rights-employee.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/gdpr-rights-researcher",
        name: "gdpr-rights-researcher",
        component: () => import("@/views/gdpr-rights-researcher.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/map",
        name: "map",
        component: () => import("@/views/map.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/selected",
        name: "map-selected",
        component: () => import("@/views/map-selected.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/product/:id",
        name: "product",
        component: () => import("@/views/product.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/user/:id/calendar",
        name: "user-calendar",
        component: () => import("@/views/user/calendar.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumResearcher,
            roles.briumFacultyAdmin,
            roles.briumUniversityAdmin,
            roles.briumSuperAdmin,
          ],
        },
      },
      {
        path: "/users",
        name: "user-options",
        component: () => import("@/views/admin/user-management.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
          ],
        },
      },
      {
        path: "template-creator",
        name: "user-template-creator",
        component: () => import("@/views/admin/template-creator.vue"),
        meta: {
          isAuthenticated: true,
          roles: [roles.briumSuperAdmin, roles.briumUniversityAdmin],
        },
      },
      {
        path: "/user/:id/settings",
        name: "user-settings",
        component: () => import("@/views/user/settings.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
            roles.briumResearcher,
          ],
        },
      },
      {
        path: "/user/:id/reporting",
        name: "user-reporting",
        component: () => import("@/views/user/reporting.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
            roles.briumResearcher,
          ],
        },
      },
      {
        path: "data-management",
        name: "user-data-management",
        component: () => import("@/views/admin/data-management.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
          ],
        },
      },
      {
        path: "documents",
        name: "user-documents",
        component: () => import("@/views/admin/documents.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
          ],
        },
      },
      {
        path: "reporting-management",
        name: "reporting-management",
        component: () => import("@/views/admin/reporting-management.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
          ],
        },
      },
      {
        path: "documents-and-reports",
        name: "documents-and-reports",
        component: () => import("@/views/admin/documents-and-reports.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
          ],
        },
      },
      {
        path: "booking-management",
        name: "user-booking-management",
        component: () => import("@/views/admin/booking-management.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
          ],
        },
      },
      {
        path: "document-management",
        name: "document-management",
        component: () => import("@/views/admin/document-management.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
          ],
        },
      },
      {
        path: "/user/:id/bookings",
        name: "user-bookings",
        component: () => import("@/views/user/bookings.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
            roles.briumResearcher,
          ],
        },
      },
      {
        path: "/user/:id/comparisons",
        name: "user-comparisons",
        component: () => import("@/views/user/comparisons.vue"),
        meta: {
          isAuthenticated: true,
          roles: [
            roles.briumSuperAdmin,
            roles.briumUniversityAdmin,
            roles.briumFacultyAdmin,
            roles.briumResearcher,
          ],
        },
      },
      {
        path: "/unauthorized",
        name: "unauthorized",
        component: () => import("@/views/401.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
      {
        path: "/:pathMatch(.*)*",
        name: "fallback",
        component: () => import("@/views/404.vue"),
        meta: {
          isAuthenticated: false,
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
